import {
  CommentaireResponseDtoProfileEnum,
  UserDtoProfileEnum,
} from 'lib_api/lib/api/gen';

import { ShouldNotHappen } from '../index';

export function userEventDataDtoProfileEnumToUserDtoProfileEnum(
  profile: CommentaireResponseDtoProfileEnum,
): UserDtoProfileEnum | undefined {
  switch (profile) {
    case CommentaireResponseDtoProfileEnum.FORCE_DE_L_ORDRE:
      return UserDtoProfileEnum.FORCE_DE_L_ORDRE;
    case CommentaireResponseDtoProfileEnum.AUTORITE_FOURRIERE:
      return UserDtoProfileEnum.AUTORITE_FOURRIERE;
    case CommentaireResponseDtoProfileEnum.ADMIN_FONCTIONNEL:
      return UserDtoProfileEnum.ADMIN_FONCTIONNEL;
    case CommentaireResponseDtoProfileEnum.GARDIEN_FOURRIERE:
      return UserDtoProfileEnum.GARDIEN_FOURRIERE;
    case CommentaireResponseDtoProfileEnum.CSU:
      return UserDtoProfileEnum.CSU;
    case CommentaireResponseDtoProfileEnum.DSR_BLR:
      return UserDtoProfileEnum.DSR_BLR;
    case CommentaireResponseDtoProfileEnum.TRIBUNAL_JUDICIAIRE:
      return UserDtoProfileEnum.TRIBUNAL_JUDICIAIRE;
    case CommentaireResponseDtoProfileEnum.COUR_APPEL:
      return UserDtoProfileEnum.COUR_APPEL;
    case CommentaireResponseDtoProfileEnum.UNITE_OPERATIONNELLE:
      return UserDtoProfileEnum.UNITE_OPERATIONNELLE;
    case CommentaireResponseDtoProfileEnum.NATIONAL_JUSTICE:
      return UserDtoProfileEnum.NATIONAL_JUSTICE;
    case null:
      return undefined;
    default:
      throw new ShouldNotHappen(profile);
  }
}
